import { useEffect, useState } from "react";
import { Receipt, Download, QrCode } from "lucide-react";
import { api } from "@/lib/api";

const rs = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
const BADGE = { paid: "bg-emerald-50 text-emerald-700 border-emerald-200", partial: "bg-gold/20 text-ink border-gold/40", unpaid: "bg-terra/10 text-terra border-terra/30" };
const LABEL = { paid: "Paid", partial: "Part paid", unpaid: "Payment due" };

export default function MyBills() {
  const [bills, setBills] = useState(null);
  useEffect(() => { api.get("/customer/bills").then((r) => setBills(r.data)).catch(() => setBills([])); }, []);
  if (!bills || bills.length === 0) return null;
  return (
    <section className="mt-10" data-testid="my-bills">
      <h3 className="font-serif text-2xl font-bold flex items-center gap-2"><Receipt size={20} className="text-terra" /> Your bills</h3>
      <p className="text-sm text-ink/60 mt-1">Receipts and tax invoices from Random Rider · Goldenscope Pvt Ltd. Download anytime.</p>
      <div className="mt-4 grid grid-cols-1 gap-4">
        {bills.map((b) => {
          const id8 = b.id.slice(0, 8);
          return (
            <div key={b.id} className="bg-white border border-ink/10 rounded-3xl p-6 flex flex-wrap items-start justify-between gap-4" data-testid={`bill-card-${id8}`}>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-mono text-xs text-terra font-semibold" data-testid={`bill-card-number-${id8}`}>{b.number}</span>
                  <span className="text-xs text-ink/40">· {b.bill_date}</span>
                  <span className={`text-[11px] font-semibold px-2.5 py-0.5 rounded-full border ${BADGE[b.status]}`} data-testid={`bill-card-status-${id8}`}>{LABEL[b.status]}</span>
                </div>
                <ul className="mt-3 space-y-1 text-sm text-ink/80" data-testid={`bill-card-items-${id8}`}>
                  {b.items.map((it, i) => <li key={i} className="flex justify-between gap-4"><span className="truncate">{it.description}{it.qty !== 1 && ` × ${it.qty}`}</span><span className="shrink-0">{rs(it.amount)}</span></li>)}
                </ul>
                <p className="mt-3 text-sm flex flex-wrap gap-x-4 gap-y-1">
                  <span className="font-bold text-ink" data-testid={`bill-card-total-${id8}`}>Total {rs(b.total)}</span>
                  {b.gst_amount > 0 && <span className="text-ink/50">incl. GST {rs(b.gst_amount)}</span>}
                  <span className="text-emerald-700">Paid {rs(Math.min(b.advance_paid, b.total))}</span>
                  {b.balance > 0 && <span className="text-terra font-semibold" data-testid={`bill-card-balance-${id8}`}>Balance {rs(b.balance)}</span>}
                </p>
              </div>
              <div className="flex flex-col gap-2 shrink-0">
                <a href={b.pdf_url} target="_blank" rel="noreferrer" data-testid={`bill-card-download-${id8}`}
                  className="inline-flex items-center gap-1.5 bg-ink text-sand text-xs font-semibold px-4 py-2 rounded-full hover:bg-terra transition-colors"><Download size={13} /> Download PDF</a>
                {b.upi_link && (
                  <a href={b.upi_link} data-testid={`bill-card-upi-${id8}`}
                    className="inline-flex items-center gap-1.5 border border-ink/15 text-xs font-semibold px-4 py-2 rounded-full hover:bg-sand transition-colors"><QrCode size={13} /> Pay {rs(b.balance)} via UPI</a>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
